import { useState } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import yqLogo from "../../../assets/img/homeV2/yq-logo.png";

export const Footer = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      setTimeout(() => setMessage(""), 5000);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${apiUrl}/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": process.env.REACT_APP_REF_API_KEY,
        },

        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Subscription failed");
      }

      setMessage(data?.message || "Subscribed successfully!");
      setEmail(""); // clear field
    } catch (err) {
      setMessage(err.message || "Something went wrong. Try again.");
    } finally {
      setLoading(false);
      setTimeout(() => setMessage(""), 5000);
    }
  };
  return (
    <footer className="text-lg-start footerBg">
      <section>
        <div className="container pt-4 pb-4 pb-md-0 ">
          <div className="row">
            {/* Left Column - Logo & Description */}
            <div className="col-lg-4 col-md-12 mt-3  text-start">
              <img
                decoding="async"
                src={yqLogo}
                alt="Yuvaquest"
                className="yqlogo-footer mb-2"
              />
              <p className="webUi footerText">
                Where every quest is a lesson, and every lesson is a quest. Our
                platform transforms education into playful activities,
                captivating young minds with interactive fun.
              </p>

              {/* Connect with Us */}
              <div className="row align-items-center mt-4">
                <div className="col-12 col-lg-4 col-md-12 text-start">
                  <h6 className="mb-3 webUi connectText">Connect with Us</h6>
                </div>
                <div className="col-12 col-lg-8 col-md-12 text-start">
                  <a
                    className="btn btn-primary btn-floating m-1"
                    style={{ backgroundColor: "#3b5998" }}
                    href="https://www.facebook.com/theyuvaquest"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    className="btn btn-primary btn-floating m-1"
                    style={{ backgroundColor: "#dd4b39" }}
                    href="https://www.instagram.com/yuvaquest"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a
                    className="btn btn-primary btn-floating m-1"
                    style={{ backgroundColor: "#a72301" }}
                    href="https://www.youtube.com/@YuvaQuest"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a
                    className="btn btn-primary btn-floating m-1"
                    style={{ backgroundColor: "#000000" }}
                    href="https://x.com/YuvaQuest"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-x-twitter">𝕏</i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-12 col-xl-2 mx-auto mt-3 text-center text-md-start webUi d-none d-md-block">
              <h6 className="webUi quickLinks">Quick Links</h6>
              <p>
                <Link className="listItems webUi text-white" to="/">
                  Home
                </Link>
              </p>
              <p>
                <Link className="listItems webUi text-white" to="/about">
                  About Us
                </Link>
              </p>
              <p>
                <Link className="listItems webUi text-white" to="/contact">
                  Contact Us
                </Link>
              </p>
              <p>
                <a
                  href="https://blog.yuvaquest.com/"
                  className="listItems webUi text-white"
                >
                  Blogs
                </a>
              </p>
              <p>
                <Link className="listItems webUi text-white" to="/faq">
                  FAQ
                </Link>
              </p>
            </div>

            {/* Newsletter */}
            <div className="col-lg-4 col-md-12 mx-auto mt-3 text-start">
              <h6 className="webUi connectText mb-3 mb-md-3_5">Newsletter</h6>
              <p className="footerText">
                Want to know what we’re up to? Signup for the newsletter and
                join us.{" "}
              </p>
              <div className="input-group">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleSubscribe}
                  disabled={loading}
                  style={{
                    backgroundColor: "#FF8C00",
                    border: "none",
                    color: "#fff",
                    fontWeight: "600",
                  }}
                >
                  {loading ? "..." : "Subscribe"}
                </button>
              </div>
              {message && (
                <p className="mt-2 footerText text-white">{message}</p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Horizontal line */}
      <hr className="footer-divider d-none d-md-block " />
      <hr className="w-100 clearfix d-md-none " />

      <div
        className="container mt-3 text-center webUi d-md-none d-block"
        style={{ marginBottom: "30px", paddingTop: "30px" }}
      >
        <h6 className="webUi quickLinks" style={{ marginBottom: "10px" }}>
          Quick Links
        </h6>
        <p>
          <Link className="listItems webUi text-white" to="/">
            Home
          </Link>
        </p>
        <p>
          <Link className="listItems webUi text-white" to="/about">
            About Us
          </Link>
        </p>
        <p>
          <Link className="listItems webUi text-white" to="/contact">
            Contact Us
          </Link>
        </p>
        <p>
          <a
            href="https://blog.yuvaquest.com/"
            className="listItems webUi text-white"
          >
            Blogs
          </a>
        </p>
        <p>
          <Link className="listItems webUi text-white" to="/faq">
            FAQ
          </Link>
        </p>
      </div>
      <div
        className="container mt-3 text-center webUi d-md-none d-block"
        style={{ marginBottom: "30px" }}
      >
        <h6
          className="webUi quickLinks"
          style={{ marginBottom: "10px", marginTop: "10px" }}
        >
          Legal Links
        </h6>
        <p>
          <Link className="listItems webUi text-white" to="/terms">
            Terms & Conditions
          </Link>
        </p>
        <p>
          <Link className="listItems webUi text-white" to="/privacy">
            Privacy Policy
          </Link>
        </p>
      </div>

      {/* Bottom Section */}
      <section className="p-3 pt-0">
        <div className="container">
          <div className="row align-items-center">
            {/* Left column */}
            <div className="col-12 col-md-12 col-lg-6 text-center text-md-start footerBottomText webUi mb-2 mb-md-0">
              <div className="d-md-block d-none">
                <Link to="/terms" className="text-white ">
                  Terms & Conditions
                </Link>
                <span className="mx-4 "></span>
                <Link to="/privacy" className="text-white">
                  Privacy Policy
                </Link>
                <span className="mx-4 "></span>

                <Link className="text-white">
                  <span
                    onClick={() => {
                      window.location.href = "mailto:support@yuvaquest.com";
                    }}
                  >
                    {" "}
                    support@yuvaquest.com
                  </span>
                </Link>
              </div>
              <div className="d-md-none d-block">
                <h6
                  className="webUi quickLinks"
                  style={{ marginBottom: "10px" }}
                >
                  Support
                </h6>
                <Link
                  className="text-white"
                  onClick={() => {
                    window.location.href = "mailto:support@yuvaquest.com";
                  }}
                >
                  support@yuvaquest.com
                </Link>
              </div>
            </div>

            {/* Right column */}
            <div className="col-12 col-lg-6 col-md-12 text-center text-lg-end footerBottomText webUi mt-0 mt-md-2 mt-lg-0">
              © {new Date().getFullYear()} Yuva Quest. All Rights Reserved.
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};
